import { Fade, Hidden, IconButton, Menu, withStyles } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'

import AppBar from '@material-ui/core/AppBar'
import NavItems from './NavItems'
import PropTypes from 'prop-types'
import Toolbar from '@material-ui/core/Toolbar'
import { bindActionCreators } from 'redux'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { isMobile } from 'utils'
import logoWhite from 'assets/novel-logo.svg'
import { openModal } from 'redux/slices/globalModal'
import { throttle } from 'lodash'
import useStyles from './styles'
import { useAuth0 } from 'libs/web-client/utils/auth0/src'

export const StyledMenu = withStyles({
    paper: {
        borderRadius: 0,
        backgroundColor: '#3e4858',
    },
})(props => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
))

const navbarTransparencyThreshold = isMobile() ? 0 : 180

const Navigation = ({ openModal, dark, transparent, position = 'fixed', home }) => {
    const { logout } = useAuth0()
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = useState(null)
    const [transparencyEnabled, setTransparencyEnabled] = useState(true)
    const open = !!anchorEl

    const handleClick = useCallback(event => {
        setAnchorEl(event.currentTarget)
    }, [])

    const handleClose = useCallback(() => {
        setAnchorEl(null)
    }, [])

    useEffect(() => {
        const handleScroll = throttle(() => {
            setTransparencyEnabled(document.documentElement.scrollTop <= navbarTransparencyThreshold)
        }, 200)

        document.addEventListener('scroll', handleScroll)

        return () => document.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <AppBar
            position="fixed"
            classes={{
                root: clsx(classes.appBar, dark && 'dark', !(transparent && transparencyEnabled) && 'dark'),
            }}
            style={{ position }}
        >
            <Toolbar classes={{ root: classes.toolbar }}>
                <div className={classes.logoWrapper}>
                    <a href={process.env.REACT_APP_COMPANY_WEBSITE_URL}>
                        <img className={classes.logo} src={logoWhite} alt="logo" />
                    </a>
                </div>
                <Hidden mdUp>
                    <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleClick}>
                        <span className={classes.hamburgerIcon} />
                    </IconButton>
                    <StyledMenu
                        id="fade-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={open}
                        onClose={handleClose}
                        TransitionComponent={Fade}
                    >
                        <NavItems home={home} mobile openModal={openModal} logout={logout} onClose={handleClose} />
                    </StyledMenu>
                </Hidden>
                <Hidden smDown>
                    <div className={classes.navItemsWrapper}>
                        <NavItems home={home} openModal={openModal} logout={logout} onClose={handleClose} />
                    </div>
                </Hidden>
            </Toolbar>
        </AppBar>
    )
}

Navigation.propTypes = {
    openModal: PropTypes.func.isRequired,
    dark: PropTypes.bool,
    home: PropTypes.bool,
}

const mapDispatchToProps = dispatch => bindActionCreators({ openModal }, dispatch)

export default connect(null, mapDispatchToProps)(Navigation)
